export const loyalty = {
	title: "Fidelización de clientes",
	commingSoon: {
		subtitle:
			"Mejore sus resultados y la experiencia de sus clientes a través de los programas de fidelidad.",
		description:
			"Podrá elegir diversas formas de cómo sus clientes acumularán puntos y los premios que ganarán. Aumente la retención de clientes incentivándolos a visitar locales o comprar un producto a cambio de puntos, entre otras opciones presentes en el módulo de fidelización.",
		cards: {
			retainCustomers: {
				title: "Retenga clientes",
				description:
					"Elija los locales participantes, premios, puntuaciones y comprometa a sus clientes.",
			},
			trackResults: {
				title: "Dé seguimiento a los resultados",
				description: "Podrá dar seguimiento al desempeño de sus programas de fidelidad.",
			},
			paper: {
				title: "Diga adiós al papelito",
				description:
					"Sus clientes podrán dar seguimiento y canjear los puntos ganados a través de Zig.app.",
			},
		},
	},
	tabs: {
		programs: {
			createSteps: {
				points: {
					pointRules: {
						npsAnswer: {
							mainTitle: "Respuesta de encuesta de satisfacción",
							description:
								"Defina el valor de los puntos que los clientes ganarán cuando respondan la encuesta de satisfacción",
							detailTitle: "Puntuación por respuesta de encuesta de satisfacción",
						},
					},
					npsAnswerPoints: {
						inputLabel: "Puntuación",
						inputPlaceholder: "Ingrese la puntuación al realizar pago por aplicación",
						continueButtonText: "Agregar puntuación",
					},
					paidWithApp: {
						inputLabel: "Puntuación",
						mainTitle: "Pago con Aplicación",
						inputPlaceholder:
							"Ingrese la puntuación por respuesta de encuesta de satisfacción",
						continueButtonText: "Agregar puntuación",
						detailsTitle: "Puntuación por Pago con Aplicación",
						subtitleRow: "Pagar cuenta o compra con aplicación",
						description:
							"Defina la puntuación que sus clientes ganarán al realizar el pago de su cuenta/compra con aplicación",
					},
				},
			},
		},
	},
};
